import * as React from "react";
const SvgFiRrAngle90 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-angle-90_svg__a)">
      <path
        fill="#062147"
        d="M24 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V1a1 1 0 1 1 2 0v18c0 1.654 1.346 3 3 3h18a1 1 0 0 1 1 1M11.562 5.508c.941.458 1.84 1.02 2.67 1.669a1 1 0 1 0 1.232-1.576 17 17 0 0 0-3.026-1.892 1 1 0 1 0-.876 1.799M5 4c1.106 0 2.211.121 3.283.359a1 1 0 1 0 .434-1.951A17 17 0 0 0 5 2a1 1 0 1 0 0 2m13.493 8.438a1 1 0 1 0 1.798-.877 17 17 0 0 0-1.892-3.026 1 1 0 0 0-1.576 1.232c.648.829 1.21 1.728 1.67 2.671m1.147 3.279c.239 1.071.36 2.176.36 3.282a1 1 0 1 0 2 0c0-1.253-.137-2.504-.408-3.718a1 1 0 1 0-1.952.435z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-angle-90_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAngle90;
